import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-behind-square-6, layers, copy 6, pages"} maskId="square-filled-radius-0-stroke-1-IconSquareBehindSquare6"><path fillRule="evenodd" clipRule="evenodd" d="M21 3H7.5V7H3V21H17V17H21V3ZM17 16H20V4H8.5V7H17V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareBehindSquare6;
